export const vi = {
  common: {
    loadError: 'Không tải được dữ liệu',
    retry: 'Thử lại',
    cancel: 'Huỷ',
    save: 'Lưu',
    saved: 'Đã lưu',
    close: 'Đóng',
    search: 'Tìm…',
    back: 'Quay lại',
  },
  chat: {
    title: 'Chat',
    empty: 'Chưa có cuộc trò chuyện nào',
    emptyHint: 'Tạo nhóm hoặc nhắn riêng cho đồng nghiệp.',
    pick: 'Chọn một cuộc trò chuyện',
    newGroup: 'Tạo nhóm',
    newDirect: 'Nhắn riêng',
    browse: 'Khám phá nhóm',
    browseEmpty: 'Không có nhóm công khai nào khác',
    join: 'Tham gia',
    joined: 'Đã tham gia nhóm',
    previewHint: 'Bạn đang xem nhóm công khai. Tham gia để gửi tin.',
    members: '{{count}} thành viên',
    info: 'Thông tin',
    mute: 'Tắt thông báo',
    unmute: 'Bật thông báo',
    muted: 'Đã tắt thông báo',
    noMessages: 'Chưa có tin nhắn. Hãy gửi tin đầu tiên.',
    older: 'Tải tin cũ hơn',
    typing: '{{name}} đang gõ…',
    placeholder: 'Nhập tin nhắn…',
    hint: 'Enter để gửi, Shift+Enter xuống dòng, @ để nhắc tên',
    mentionPick: 'Chọn người để nhắc tên…',
    send: 'Gửi',
    attach: 'Đính kèm file',
    uploading: 'Đang tải lên…',
    recalled: 'Tin nhắn đã được thu hồi',
    edited: 'đã sửa',
    edit: 'Sửa',
    recall: 'Thu hồi',
    recallConfirm: 'Thu hồi tin nhắn này?',
    recallHint: 'Mọi người sẽ thấy "Tin nhắn đã được thu hồi".',
    you: 'Bạn',
    today: 'Hôm nay',
    yesterday: 'Hôm qua',
    file: 'File đính kèm',
    archived: 'Kênh đã lưu trữ (đơn vị / dự án không còn hoạt động): chỉ xem, không gửi tin.',
    react: 'Thêm biểu cảm',
    messageButton: 'Nhắn tin',
    projectChannel: 'Kênh chat',
  },
  thread: {
    title: 'Luồng trả lời',
    reply: 'Trả lời trong luồng',
    replies_one: '{{count}} trả lời',
    replies_other: '{{count}} trả lời',
    placeholder: 'Trả lời…',
    empty: 'Chưa có trả lời.',
  },
  pin: {
    pin: 'Ghim tin',
    unpin: 'Bỏ ghim',
    pinned: 'Đã ghim',
    list: 'Tin đã ghim',
    none: 'Chưa có tin nào được ghim.',
  },
  kinds: {
    unit: 'Kênh đơn vị',
    project: 'Kênh dự án',
    autoMembers: 'Thành viên tự cập nhật theo đơn vị / dự án.',
    openUnit: 'Xem sơ đồ tổ chức',
    openProject: 'Mở dự án',
  },
  group: {
    name: 'Tên nhóm',
    description: 'Mô tả',
    private: 'Nhóm riêng tư',
    public: 'Nhóm công khai',
    privateHint: 'Chỉ thành viên thấy nhóm. Bỏ chọn để ai cũng tìm và tham gia được.',
    people: 'Thành viên',
    addPeople: 'Thêm người…',
    admin: 'Quản trị nhóm',
    remove: 'Mời ra khỏi nhóm',
    leave: 'Rời nhóm',
    leaveConfirm: 'Rời nhóm này?',
    left: 'Đã rời nhóm',
    created: 'Đã tạo nhóm',
  },
  direct: { pick: 'Chọn người để nhắn…' },
  errors: {
    generic: 'Không thực hiện được. Thử lại sau.',
    'core.validation_failed': 'Thông tin chưa hợp lệ.',
    'core.forbidden': 'Bạn không có quyền làm việc này.',
    'chat.not_member': 'Hãy tham gia nhóm trước.',
    'chat.recalled': 'Tin nhắn đã bị thu hồi.',
    'chat.self': 'Hãy chọn người khác.',
    'chat.unknown_user': 'Không tìm thấy người này.',
    'chat.file_not_yours': 'Chỉ đính kèm được file do bạn tải lên.',
    'chat.archived': 'Kênh đã lưu trữ, không gửi tin được.',
    'chat.nested_thread': 'Chỉ trả lời được tin đầu luồng.',
    'chat.pin_reply': 'Chỉ ghim được tin đầu luồng.',
    'chat.not_group': 'Thành viên kênh này tự cập nhật theo đơn vị / dự án.',
    'core-files.too_large': 'File quá lớn (tối đa 10 MB).',
    'core-files.unsupported_type': 'Chỉ nhận PDF hoặc ảnh (JPG, PNG, WebP).',
  },
};

export const en: typeof vi = {
  common: {
    loadError: 'Could not load data',
    retry: 'Retry',
    cancel: 'Cancel',
    save: 'Save',
    saved: 'Saved',
    close: 'Close',
    search: 'Search…',
    back: 'Back',
  },
  chat: {
    title: 'Chat',
    empty: 'No conversations yet',
    emptyHint: 'Create a group or message a colleague.',
    pick: 'Pick a conversation',
    newGroup: 'New group',
    newDirect: 'Direct message',
    browse: 'Browse groups',
    browseEmpty: 'No other public groups',
    join: 'Join',
    joined: 'Joined the group',
    previewHint: 'You are previewing a public group. Join to post.',
    members: '{{count}} members',
    info: 'Details',
    mute: 'Mute',
    unmute: 'Unmute',
    muted: 'Muted',
    noMessages: 'No messages yet. Say hello.',
    older: 'Load older messages',
    typing: '{{name}} is typing…',
    placeholder: 'Write a message…',
    hint: 'Enter to send, Shift+Enter for a new line, @ to mention',
    mentionPick: 'Pick someone to mention…',
    send: 'Send',
    attach: 'Attach a file',
    uploading: 'Uploading…',
    recalled: 'This message was recalled',
    edited: 'edited',
    edit: 'Edit',
    recall: 'Recall',
    recallConfirm: 'Recall this message?',
    recallHint: 'Everyone will see "This message was recalled".',
    you: 'You',
    today: 'Today',
    yesterday: 'Yesterday',
    file: 'Attachment',
    archived: 'Archived channel (the unit / project is closed): read-only.',
    react: 'Add reaction',
    messageButton: 'Message',
    projectChannel: 'Chat channel',
  },
  thread: {
    title: 'Thread',
    reply: 'Reply in thread',
    replies_one: '{{count}} reply',
    replies_other: '{{count}} replies',
    placeholder: 'Reply…',
    empty: 'No replies yet.',
  },
  pin: {
    pin: 'Pin message',
    unpin: 'Unpin',
    pinned: 'Pinned',
    list: 'Pinned messages',
    none: 'Nothing pinned yet.',
  },
  kinds: {
    unit: 'Unit channel',
    project: 'Project channel',
    autoMembers: 'Members follow the unit / project.',
    openUnit: 'Open the org chart',
    openProject: 'Open the project',
  },
  group: {
    name: 'Group name',
    description: 'Description',
    private: 'Private group',
    public: 'Public group',
    privateHint: 'Only members see it. Untick to let anyone find and join it.',
    people: 'Members',
    addPeople: 'Add people…',
    admin: 'Group admin',
    remove: 'Remove from group',
    leave: 'Leave group',
    leaveConfirm: 'Leave this group?',
    left: 'Left the group',
    created: 'Group created',
  },
  direct: { pick: 'Choose someone…' },
  errors: {
    generic: 'Could not complete. Try again later.',
    'core.validation_failed': 'Some information is invalid.',
    'core.forbidden': 'You are not allowed to do this.',
    'chat.not_member': 'Join the group first.',
    'chat.recalled': 'This message was recalled.',
    'chat.self': 'Choose someone else.',
    'chat.unknown_user': 'Person not found.',
    'chat.file_not_yours': 'Attach only files you uploaded.',
    'chat.archived': 'This channel is archived.',
    'chat.nested_thread': 'Reply to the first message of the thread.',
    'chat.pin_reply': 'Only first messages of threads can be pinned.',
    'chat.not_group': 'Members of this channel follow the unit / project.',
    'core-files.too_large': 'File too large (10 MB max).',
    'core-files.unsupported_type': 'Only PDF or images (JPG, PNG, WebP).',
  },
};
